import React from 'react'
import './LotDetailsStyles.css'
import thumbnail from '../../assets/images/default-thumbnail.jpg'
import CustomBreadcrumbs from '@/custom/components/atoms/CustomBreadcrumbs'
export const AuctionLot = () => {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Auction', link: '/auction-details' },
        { label: 'Auction Lot Details', link: '/auction-lot-view' },
    ]

    return (
        <>
            <div className="lot-details-parent">
                <div className="container" style={{ backgroundColor: '#f5f7fa' }}>
                    <CustomBreadcrumbs items={breadcrumbs} />
                </div>
                <div className="lot-details-container">
                    <div className="lot-card">
                        <div className="image-section">
                            <div className="image-placeholder">
                                <img src={thumbnail} alt="Lot" className="lot-image" />
                            </div>
                        </div>
                        <div className="details-section">
                            <div className="lot-details">
                                <div className="lot-title">LOT NO. 1</div>
                                <div className="lot-subtitle">SCRAP GLASS</div>
                                <table className="details-table">
                                    <tbody>
                                        <tr>
                                            <td>Brand</td>
                                            <td>:</td>
                                            <td>Other</td>
                                        </tr>
                                        <tr>
                                            <td>Category</td>
                                            <td>:</td>
                                            <td>Other</td>
                                        </tr>
                                        <tr>
                                            <td>Year Of Mfg.</td>
                                            <td>:</td>
                                            <td>1900</td>
                                        </tr>
                                        <tr>
                                            <td>Model</td>
                                            <td>:</td>
                                            <td>Other</td>
                                        </tr>
                                        <tr>
                                            <td>Date of invoice</td>
                                            <td>:</td>
                                            <td>NA</td>
                                        </tr>
                                        <tr>
                                            <td>Uom</td>
                                            <td>:</td>
                                            <td>MT</td>
                                        </tr>
                                        <tr>
                                            <td>Reg.No./S.No.</td>
                                            <td>:</td>
                                            <td>NA</td>
                                        </tr>
                                        <tr>
                                            <td>Start Price</td>
                                            <td>:</td>
                                            <td>5000.00</td>
                                        </tr>
                                        <tr>
                                            <td>Bid Increment</td>
                                            <td>:</td>
                                            <td>NA</td>
                                        </tr>
                                        <tr>
                                            <td>Start Date</td>
                                            <td>:</td>
                                            <td>08-05-2025</td>
                                        </tr>
                                        <tr>
                                            <td>Location</td>
                                            <td>:</td>
                                            <td>Mundra, Gujarat, India</td>
                                        </tr>
                                        <tr>
                                            <td>Additional Info</td>
                                            <td>:</td>
                                            <td>AS IS WHERE IS BASIS</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div className="button-section">
                                <button className="view-auction-btn">VIEW ONLINE AUCTION</button>
                            </div>
                        </div>
                    </div>
                    <div className="button-section">
                        <button className="back-btn">Back</button>
                    </div>
                </div>
            </div>
        </>
    )
}
